module.exports = __webpack_public_path__ + "img/tr-Smoke.7cbd6492.jpg";